module.exports = __webpack_public_path__ + "img/barcode.9b973a96.png";